export function getAudioPlayerController(application) {
  return application.getControllerForElementAndIdentifier(
    document.querySelector('[data-audio-player]'),
    'media--audio-player'
  );
}
